import { render, staticRenderFns } from "./ScoreLineTable.vue?vue&type=template&id=72282c66&scoped=true&"
import script from "./ScoreLineTable.vue?vue&type=script&lang=js&"
export * from "./ScoreLineTable.vue?vue&type=script&lang=js&"
import style0 from "./ScoreLineTable.vue?vue&type=style&index=0&id=72282c66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72282c66",
  null
  
)

export default component.exports